var _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessful(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4761 0.148571V0.247619V10.1524C76.2171 12.8267 91.619 32.5867 88.9447 54.3276C86.6666 72.3543 72.5028 86.6667 54.4761 88.7962V98.7009C81.7142 95.9771 101.524 71.8095 98.7999 44.5714C96.5714 21.0476 77.9009 2.47619 54.4761 0.148571ZM44.5714 0.297142C34.9142 1.23809 25.7028 4.95238 18.1752 11.1924L25.2571 18.5219C30.8037 14.0648 37.4895 11.1924 44.5714 10.2019V0.297142ZM11.1923 18.1752C4.95232 25.7029 1.23803 34.8648 0.247559 44.5714H10.1523C11.0933 37.5391 13.8666 30.8533 18.2742 25.2571L11.1923 18.1752ZM66.8571 32.1905L42.6895 56.3581L32.1904 45.859L26.9409 51.1086L42.6895 66.8571L72.1066 37.44L66.8571 32.1905ZM0.297082 54.4762C1.28756 64.1829 5.10089 73.3448 11.2418 80.8724L18.2742 73.7905C13.9161 68.1943 11.0933 61.5086 10.2018 54.4762H0.297082ZM25.2571 81.0705L18.1752 87.8552C25.6533 94.0952 34.8647 98.0076 44.5714 99.0476V89.1429C37.539 88.2514 30.8533 85.4286 25.2571 81.0705Z",
    fill: "#13497B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_165_643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4761 0.148571V0.247619V10.1524C76.2171 12.8267 91.619 32.5867 88.9447 54.3276C86.6666 72.3543 72.5028 86.6667 54.4761 88.7962V98.7009C81.7142 95.9771 101.524 71.8095 98.7999 44.5714C96.5714 21.0476 77.9009 2.47619 54.4761 0.148571ZM44.5714 0.297142C34.9142 1.23809 25.7028 4.95238 18.1752 11.1924L25.2571 18.5219C30.8037 14.0648 37.4895 11.1924 44.5714 10.2019V0.297142ZM11.1923 18.1752C4.95232 25.7029 1.23803 34.8648 0.247559 44.5714H10.1523C11.0933 37.539 13.8666 30.8533 18.2742 25.2571L11.1923 18.1752ZM0.297082 54.4762C1.28756 64.1829 5.10089 73.3448 11.2418 80.8724L18.2742 73.7905C13.9161 68.1943 11.0933 61.5086 10.2018 54.4762H0.297082ZM25.2571 81.0705L18.1752 87.8552C25.6533 94.0952 34.8647 98.0076 44.5714 99.0476V89.1429C37.539 88.2514 30.8533 85.4286 25.2571 81.0705Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_165_643)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7921 29.8154L42.5679 57.6368L30.7093 49.3824L26.7508 55.4256L44.5387 67.8071L66.7214 33.9425L60.7921 29.8154Z",
    fill: "#46D0D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/successful.6331884984d00c076bc227677ee69f7d.svg";
export { ForwardRef as ReactComponent };